import * as React from "react";
import { useCallback, useRef } from "react";
import lowerCase from "lodash/lowerCase";
import { CountBadge, Pluralize, Tooltip } from "components/common";
import useEntityCollectionStatus from "collections/hooks/useEntityCollectionStatus";
import { createGRN } from "logic/permissions/GRN";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
const EntityCollectionCell = ({ entityId, entityType }) => {
  var _a;
  const entityGRN = createGRN(entityType, entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entityId);
  const count = (data == null ? void 0 : data.length) || 0;
  const buttonRef = useRef();
  const { toggleSection, expandedSections } = useExpandedSections();
  const collectionSectionIsOpen = (_a = expandedSections == null ? void 0 : expandedSections[entityId]) == null ? void 0 : _a.includes("collections");
  const toggleCollectionSection = useCallback(() => toggleSection(entityId, "collections"), [entityId, toggleSection]);
  if (isFetching || isError) {
    return null;
  }
  if (count === 0) {
    return null;
  }
  const label = /* @__PURE__ */ React.createElement("span", null, "This ", lowerCase(entityType), " is in ", count, " ", /* @__PURE__ */ React.createElement(Pluralize, { value: count, plural: "collections", singular: "collection" }), ".");
  const collectionSectionTitle = `${collectionSectionIsOpen ? "Hide" : "Show"} collections`;
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label }, /* @__PURE__ */ React.createElement(
    CountBadge,
    {
      count,
      iconName: collectionSectionIsOpen ? "keyboard_arrow_up" : "keyboard_arrow_down",
      title: collectionSectionTitle,
      onClick: toggleCollectionSection,
      ref: buttonRef
    }
  ));
};
export const getCollectionsCustomColumnRenderer = (entityType) => ({
  collections: {
    renderCell: (_collections, entity) => /* @__PURE__ */ React.createElement(EntityCollectionCell, { entityId: entity.id, entityType }),
    staticWidth: "matchHeader",
    textAlign: "right"
  }
});
export default EntityCollectionCell;
